import React from "react";
import "./ErrorMessage.css";
import Typography from "../Typography/Typography";
import CloseIcon from "../../../assets/svgs/closeIcon.svg?react";

const ErrorMessage = ({ text, onClick }) => {
    return (
        <div
            onClick={onClick}
            className=" w-screen h-screen fixed top-0 left-0 bg-[#0C214D60] z-[9999999999999999] flex items-center justify-center"
        >
            <div className="relative max-w-[18.75rem] w-full p-5 bg-white rounded-lg">
                <CloseIcon className="errorMessage__closeBtn" />
                <Typography type="body2" className="!font-darwinProBold mb-2">
                    Message:
                </Typography>
                <Typography type="body2">{text || "text"}</Typography>
            </div>
        </div>
    );
};

export default ErrorMessage;
